<template>
  <div>
    <header>
      <div class="bloque-cabecera">
        <div class="logo"></div>
      </div>
    </header>
    <br />

    <section>
        <div class="bloque-datos">
            <v-row justify="center">
                <v-col align="center" class="col-12">
                    <menuPage></menuPage>
                </v-col>
            </v-row>
            <div class="bloque-datos-titulo">
                <p class="justifyLeft" style="font-family: Heebo; font-weight: normal">
                    Para reparar tu dispositivo, necesitamos que rellenes los datos que te solicitamos a continuación (los marcados con (*) son obligatorios).
                </p><br />
                <p class="justifyLeft" style="font-family: Heebo; font-weight: normal">
                    En un plazo máximo de 48 horas laborables desde que nos envíes, contactaremos contigo para ir a recoger tu dispositivo.
                </p><br />
                <p class="justifyLeft" style="font-family: Heebo; font-weight: normal">
                    La recogida y devolución del dispositivo no tienen costes asociados y la reparación, si tu dispositivo está en garantía, tampoco.
                </p><br />
                <p class="justifyLeft" style="font-family: Heebo; font-weight: normal">
                    En caso de no estar en garantía, te facilitaremos un presupuesto.
                </p><br />
                <p class="justifyLeft" style="font-family: Heebo; font-weight: normal">
                    Rellene los siguientes campos para completar la gestión de
                    reparación de su dispositivo.
                </p>
            </div>

            <br />
            <br />
            <div class="bloque-alerta">
                <span id="lblMensaje" style="color: #869296 ;font-family: Heebo; font-weight: normal"></span>
            </div>
            <br />
            <div class="bloque-datos-campos">
                <v-alert v-if="incidencia != ''"
                         dense
                         outlined
                         prominent
                         text
                         :type="tipoTextoIncidencia"
                         style="font-family: Heebo; font-weight: normal">
                    {{ incidencia }}
                </v-alert>
                <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">TELÉFONO DE CONTACTO *</div>
                <div class="row-campos">
                    <input v-model="localTelefono"
                           name="txtTelefono"
                           maxlength="9"
                           id="txtTelefono"
                           tabindex="1"
                           class="text-datos"
                           type="tel" />
                    <span id="lblMensaje1"
                          style="color: #ff0000"
                          v-html="errorTelefono"
                          style="font-family: Heebo; font-weight: normal"></span>
                </div>
                <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">NÚMERO DE ABONADO *</div>
                <div class="row-campos">
                    <input v-model="localAbonado"
                           name="txtAbonado"
                           maxlength="9"
                           id="txtAbonado"
                           tabindex="2"
                           class="text-datos"
                           type="tel" />
                    <span id="lblMensaje2"
                          style="color: #ff0000;font-family: Heebo; font-weight: normal"
                          v-html="errorAbonado" ></span>
                </div>
                <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">NOMBRE *</div>
                <div class="row-campos">
                    <input v-model="formulario.metaData.nombreCliente"
                           name="txtNombre"
                           maxlength="40"
                           id="txtNombre"
                           tabindex="3"
                           class="text-datos"
                           type="text" />
                    <span id="lblMensaje3"
                          style="color: #ff0000;font-family: Heebo; font-weight: normal"
                          v-html="erroresObligatorios.nombre"></span>
                </div>
                <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">EMAIL *</div>
                <div class="row-campos">
                    <input v-model="localEmail"
                           name="txtEmail"
                           maxlength="60"
                           id="txtEmail"
                           tabindex="4"
                           class="text-datos"
                           type="email" />
                    <span id="lblMensaje4"
                          style="color: #ff0000;font-family: Heebo; font-weight: normal"
                          v-html="errorEmail"></span>
                </div>
                <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">SÍNTOMA DE LA AVERÍA *</div>
                <div class="row-campos">
                    <input v-model="formulario.linea.sintomaAveria"
                           name="txtSintoma"
                           id="txtSintoma"
                           tabindex="5"
                           class="text-datos"
                           type="email" />
                    <span id="lblMensaje5"
                          style="color: #ff0000;font-family: Heebo; font-weight: normal"
                          v-html="erroresObligatorios.sintoma"></span>
                </div>
                <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">DIRECCIÓN *</div>
                <div class="row-campos">
                    <input v-model="formulario.metaData.direccionCliente"
                           name="txtDireccion"
                           maxlength="80"
                           id="txtDireccion"
                           tabindex="6"
                           class="text-datos"
                           type="text"
                           style="color: #6f737d" />
                    <span id="lblMensaje6"
                          style="color: #ff0000;font-family: Heebo; font-weight: normal"
                          v-html="erroresObligatorios.direccion"></span>
                </div>
                <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">CÓDIGO POSTAL *</div>
                <div class="row-campos">
                    <input v-model="formulario.metaData.cpCliente"
                           name="txtCodpos"
                           maxlength="7"
                           id="txtCodpos"
                           tabindex="7"
                           class="text-datos"
                           type="number"
                           style="color: #6f737d" />
                    <span id="lblMensaje7"
                          style="color: #ff0000;font-family: Heebo; font-weight: normal"
                          v-html="erroresObligatorios.cp"></span>
                </div>
                <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">POBLACIÓN *</div>
                <div class="row-campos">
                    <input v-model="formulario.metaData.poblacionCliente"
                           name="txtPoblacion"
                           maxlength="40"
                           id="txtPoblacion"
                           tabindex="8"
                           class="text-datos"
                           type="text"
                           style="color: #6f737d" />
                    <span id="lblMensaje8"
                          style="color: #ff0000;font-family: Heebo; font-weight: normal"
                          v-html="erroresObligatorios.poblacion"></span>
                </div>
                <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">
                    HORARIO DE CONTACTO * <br />(Cuando contactemos tiene que tener
                    acceso al dispositivo)
                </div>
                <span id="lblMensaje9"
                      style="color: #ff0000"
                      v-html="erroresObligatorios.horarioContacto"></span>
                <div class="row-etiqueta"style="font-family: Heebo; font-weight: normal">HORARIO DESDE *</div>
                <div class="row-campos">
                    <input v-model="localHorarioDesde"
                           name="txtHoraDesde"
                           id="txtHoraDesde"
                           tabindex="17"
                           class="text-datos"
                           type="time"
                           style="color: #6f737d" />
                </div>
                <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">HORARIO HASTA *</div>
                <div class="row-campos">
                    <input v-model="localHorarioHasta"
                           name="txtHoraHasta"
                           id="txtHoraHasta"
                           tabindex="18"
                           class="text-datos"
                           type="time"
                           style="color: #6f737d" />
                </div>
                <br />
                <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">ALBARÁN</div>
                <div class="row-campos">
                    <!--<input name="txtAlbaran" maxlength="40" id="txtAlbaran" tabindex="8" class="text-datos" type="file" style="color:#6F737D;">-->
                    <input-file v-model="formulario.albaran" />
                    <span id="lblMensaje2"
                          style="color: #ff0000"
                          v-html="erroresObligatorios.albaran"></span>
                </div>
                <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">NÚMERO DE SERIE</div>
                <div class="row-campos">
                    <input v-model="formulario.metaData.sn"
                           name="txtSN"
                           maxlength="20"
                           id="txtSN"
                           tabindex="9"
                           class="text-datos"
                           type="text"
                           style="color: #6f737d" />
                    <div style="display: inline; margin-left: -30px; padding-bottom: 30px">
                        <img @click="modalSN = true"
                             src="/img/formulario Rent 2 Rent/ico_ayuda.png"
                             alt="?" />
                    </div>
                </div>
                <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">IMEI</div>
                <div class="row-campos">
                    <input v-model="formulario.metaData.imei"
                           name="txtIMEI"
                           maxlength="20"
                           id="txtIMEI"
                           tabindex="10"
                           class="text-datos"
                           type="text"
                           style="color: #6f737d" />
                    <div style="display: inline; margin-left: -30px; padding-bottom: 30px">
                        <img @click="modalIMEI = true"
                             src="/img/formulario Rent 2 Rent/ico_ayuda.png"
                             alt="?" />
                    </div>
                </div>
                <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">FAMILIA</div>
                <div class="row-campos">
                    <div class="select">
                        <select v-if="TiposModelos != null"
                                v-model="pedirDesplegables.idTipoModelo"
                                name="cmbTipoModelo"
                                id="cmbTipoModelo"
                                :disabled="TiposModelos.length == 1"
                                tabindex="11">
                            <option v-for="tipoModelo in TiposModelos"
                                    :key="tipoModelo.ID"
                                    selected
                                    :value="tipoModelo.ID">
                                {{ tipoModelo.DESCRIPCION }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">MARCA</div>
                <div v-if="pedirDesplegables.idTipoModelo != 1" class="row-campos">
                    <div class="select">
                        <select v-if="Fabricantes != null"
                                v-model="pedirDesplegables.idMarca"
                                name="cmbMarca"
                                id="cmbMarca"
                                @change="changeSelectMarca"
                                tabindex="12">
                            <option v-for="fabricante in Fabricantes"
                                    :key="fabricante.ID"
                                    :value="fabricante.ID">
                                {{ fabricante.DESCRIPCION }}
                            </option>
                        </select>
                    </div>
                </div>
                <div v-else class="row-campos">
                    <input v-model="formulario.metaData.marca"
                           name="txtMARCA"
                           type="text"
                           id="txtMARCA"
                           tabindex="14"
                           class="text-datos"
                           style="color: #6f737d" />
                </div>
                <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">MODELO</div>
                <div v-if="pedirDesplegables.idTipoModelo != 1" class="row-campos">
                    <div class="select">
                        <select v-if="Modelos != null"
                                v-model="formulario.idModelo"
                                name="cmbModelo"
                                id="cmbModelo"
                                tabindex="13">
                            <option v-for="modelo in Modelos"
                                    :key="modelo.ID"
                                    :value="modelo.ID">
                                {{ modelo.DESCRIPCION }}
                            </option>
                        </select>
                    </div>
                </div>
                <div v-else class="row-campos">
                    <input v-model="formulario.metaData.modelo"
                           name="txtMODELO"
                           type="text"
                           id="txtMODELO"
                           tabindex="14"
                           class="text-datos"
                           style="color: #6f737d" />
                </div>
                <div class="row-etiqueta">COLOR</div>
                <div class="row-campos">
                    <input v-model="formulario.metaData.color"
                           name="txtCOLOR"
                           type="text"
                           id="txtCOLOR"
                           tabindex="14"
                           class="text-datos"
                           style="color: #6f737d" />
                </div>
                <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">DNI</div>
                <div class="row-campos">
                    <input v-model="formulario.metaData.dniCliente"
                           name="txtDNI"
                           type="text"
                           id="txtDNI"
                           tabindex="14"
                           class="text-datos"
                           style="color: #6f737d" />
                </div>
                <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">FECHA DE COMPRA</div>
                <div class="row-campos">
                    <input v-model="formulario.metaData.fechaCompra"
                           name="txtFechaCompra"
                           type="date"
                           id="txtFechaCompra"
                           tabindex="15"
                           class="text-datos"
                           style="color: #6f737d" />
                </div>

                <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">OBSERVACIONES</div>
                <div class="row-campos">
                    <input v-model="formulario.linea.observaciones"
                           name="txtObservaciones"
                           maxlength="250"
                           id="txtObservaciones"
                           tabindex="16"
                           class="text-datos"
                           type="text"
                           style="color: #6f737d" />
                </div>
                <br /><br />
                <div class="requerimiento">
                    <label style="font-family: Heebo; font-weight: normal">
                        Este es un <strong>formulario específico</strong> para el caso en
                        que quiera <strong>reparar su dispositivo</strong>.
                    </label><br /><br />
                    <label style="font-family: Heebo; font-weight: normal">
                        Si el <strong>equipo esta defectuoso en origen</strong>, debe
                        realizar la solicitud dentro de los primeros 15 días desde la
                        adquisición de su dispositivo y debe presentar el dispositivo en
                        su embalaje original con todos los accesorios y manuales.
                    </label><br /><br />
                    <label style="font-family: Heebo; font-weight: normal">
                        <strong>* Deberá llamar al 1004</strong> Si el dispositivo se ha
                        <strong>dañado en el transporte</strong> o quiere
                        <strong>desistir de la compra realizada</strong> y devolver el
                        equipo, y solicitar la tramitación de un desistimiento.
                    </label><br /><br />
                    <label style="font-family: Heebo; font-weight: normal">
                        * Solo aplica para entregas en domicilio del cliente.
                    </label>
                </div>
                <br />
                <br />
                <!--
        <div class="requerimiento">
            <div style="text-decoration: underline; font-size: 12px">
                REQUERIMIENTO:
            </div>
            <br />
            Dentro de los primeros 15 días desde la adquisición de su dispositivo de Fusión,
            debe presentar el dispositivo en su embalaje original todos los accesorios, cables, mando y manuales,
            para poder tramitar la recogida en su domicilio como defectuoso en origen.
        </div><br />
        <br />-->

                <v-btn @click="comprobarCampos" color="#9be51a" x-large block style="font-family: Heebo; font-weight: normal">ENVIAR</v-btn>
                <br />
                <br />
            </div>
        </div>

      <v-dialog v-model="modalSN" max-width="800">
        <v-card>
          <v-img src="/img/formulario Rent 2 Rent/SN.jpg"></v-img>
        </v-card>
      </v-dialog>

      <v-dialog v-model="modalIMEI" max-width="800">
        <v-card>
          <v-img src="/img/formulario Rent 2 Rent/ejemplo Imei.png"></v-img>
        </v-card>
      </v-dialog>
    </section>

    <footer>
      <div style="height: 30px"></div>
      <div class="bloque-alerta">
        <span id="lblMensaje12"></span>
      </div>
    </footer>
  </div>
</template>

<script>
import incidencia_formulario from "@/Modelos/IncidenciaFormulario";

export default {
  layout: "noZeleris",
  components: {
      inputFile: () => import("@/components/fusion/input-file"),
     
  },
  created() {
    this.formulario = incidencia_formulario;
    this.getDesplegables();
  },

  data: () => ({
    //Iniciales
    TiposModelos: undefined,
    Fabricantes: undefined,
    Modelos: undefined,
    modalSN: false,
    modalIMEI: false,
    //Flujo
    pedirDesplegables: {
      idTipoModelo: null,
      idMarca: null,
    },
    localTelefono: "",
    errorTelefono: "",
    localAbonado: "",
    errorAbonado: "",
    localEmail: "",
    errorEmail: "",
    localHorarioDesde: "",
    localHorarioHasta: "",
    erroresObligatorios: {
      nombre: "",
      sintoma: "",
      direccion: "",
      cp: "",
      poblacion: "",
      albaran: "",
      horarioContacto: "",
    },
    //Final
    formulario: {},
    enviandoIncidencia: false,
    incidencia: "",
    tipoTextoIncidencia: "",
  }),

  watch: {
    pedirDesplegables: {
      deep: true,
      handler(valor) {
        if (valor.idMarca != null && valor.idTipoModelo != null)
          this.getDesplegables();
      },
    },
    localHorarioDesde(nuevo) {
      if (nuevo != "" && this.localHorarioHasta != "")
        this.formulario.metaData.horarioContacto =
          "Desde " + nuevo + " hasta " + this.localHorarioHasta;
    },
    localHorarioHasta(nuevo) {
      if (nuevo != "" && this.localHorarioDesde != "")
        this.formulario.metaData.horarioContacto =
          "Desde " + this.localHorarioDesde + " hasta " + nuevo;
    },
  },

  computed: {
    formularioCompleto() {
      return (
        this.formulario.metaData.telefonoCliente != null &&
        this.formulario.metaData.telefonoCliente != "" &&
        this.formulario.metaData.numeroAbonadoCliente != null &&
        this.formulario.metaData.numeroAbonadoCliente != "" &&
        this.formulario.metaData.nombreCliente != null &&
        this.formulario.metaData.nombreCliente != "" &&
        this.formulario.metaData.emailCliente != null &&
        this.formulario.metaData.emailCliente != "" &&
        this.formulario.linea.sintomaAveria != null &&
        this.formulario.linea.sintomaAveria != "" &&
        this.formulario.metaData.direccionCliente != null &&
        this.formulario.metaData.direccionCliente != "" &&
        this.formulario.metaData.cpCliente != null &&
        this.formulario.metaData.cpCliente != "" &&
        this.formulario.metaData.poblacionCliente != null &&
        this.formulario.metaData.poblacionCliente != "" &&
        this.formulario.metaData.horarioContacto != null &&
        this.formulario.metaData.horarioContacto != ""
      );
    },
  },

  methods: {
    getDesplegables() {
      this.$API.getDesplegables(this.pedirDesplegables).then((response) => {
        if (response.hasOwnProperty("tiposModelos")) {
          this.TiposModelos = response.tiposModelos;
          if (response.tiposModelos.length == 1)
            this.pedirDesplegables.idTipoModelo = response.tiposModelos[0].ID;
        }
        if (response.hasOwnProperty("marcas"))
          this.Fabricantes = response.marcas;
        if (response.hasOwnProperty("modelos")) this.Modelos = response.modelos;
      });
      },

      changeSelectMarca() {

          if (this.pedirDesplegables.idTipoModelo == 1 && this.pedirDesplegables.idMarca == 77) {
              if (window.confirm('Para poder recogerse el dispositivo tiene que estar desactivada la función Buscar Mi iPhone. Si necesita ayuda, pulse aceptar para leer el documento')) {
                  window.open('/doc/Desactivar_Buscar_iPhone_2020.pdf', '_blank');
              };
          }

      },

    //Validaciones de campos
    comprobarCampos() {
      this.comprobarTelefono();
      this.comprobarAbonado();
      this.comprobarEmail();
      this.comprobarObligatorios();

      if (!this.formularioCompleto) window.scrollTo(0, 0);
      else this.enviar();
    },
    comprobarTelefono() {
      this.formulario.metaData.telefonoCliente = "";
      this.errorTelefono = "";
      if (this.localTelefono == "")
        this.errorTelefono =
          "El campo <b>'Teléfono de Contacto'</b> es obligatorio y no puede estar vacío";
      else if (!/^[0-9]{9}/.test(this.localTelefono))
        this.errorTelefono = this.errorTelefono =
          "El campo <b>'Teléfono de Contacto'</b> no tiene un formato correcto, 9 dígitos númericos sin espacios";
      else this.formulario.metaData.telefonoCliente = this.localTelefono;
    },
    comprobarAbonado() {
      this.formulario.metaData.numeroAbonadoCliente = "";
      this.errorAbonado = "";
      if (this.localAbonado == "")
        this.errorAbonado =
          "El campo <b>'Número de Abonado'</b> es obligatorio y no puede estar vacío";
      else if (!/^[0-9]{9}/.test(this.localAbonado))
        this.errorAbonado =
          "El campo <b>'Número de Abonado'</b> no tiene un formato correcto, 9 dígitos númericos sin espacios";
      else this.formulario.metaData.numeroAbonadoCliente = this.localAbonado;
    },
    comprobarEmail() {
      this.formulario.metaData.emailCliente = "";
      this.errorEmail = "";
      if (this.localEmail == "")
        this.errorEmail =
          "El campo <b>'Email'</b> es obligatorio y no puede estar vacío";
      else if (!this.localEmail.includes("@") || !this.localEmail.includes("."))
        this.errorEmail =
          "El campo <b>'Email'</b> no tiene un formato de email válido";
      else this.formulario.metaData.emailCliente = this.localEmail;
    },
    comprobarObligatorios() {
      Object.entries(this.erroresObligatorios).forEach(([key, value]) => {
        this.erroresObligatorios[key] = "";
      });
      if (
        this.formulario.metaData.nombreCliente == null ||
        this.formulario.metaData.nombreCliente == ""
      )
        this.erroresObligatorios.nombre =
          "El campo <b>'Nombre'</b> es obligatorio y no puede estar vacío";
      if (
        this.formulario.linea.sintomaAveria == null ||
        this.formulario.linea.sintomaAveria == ""
      )
        this.erroresObligatorios.sintoma =
          "El campo <b>'Síntoma de la Avería'</b> es obligatorio y no puede estar vacío";
      if (
        this.formulario.metaData.direccionCliente == null ||
        this.formulario.metaData.direccionCliente == ""
      )
        this.erroresObligatorios.direccion =
          "El campo <b>'Dirección'</b> es obligatorio y no puede estar vacío";
      if (
        this.formulario.metaData.cpCliente == null ||
        this.formulario.metaData.cpCliente == ""
      )
        this.erroresObligatorios.cp =
          "El campo <b>'Código Postal'</b> es obligatorio y no puede estar vacío";
      if (
        this.formulario.metaData.poblacionCliente == null ||
        this.formulario.metaData.poblacionCliente == ""
      )
        this.erroresObligatorios.poblacion =
          "El campo <b>'Población'</b> es obligatorio y no puede estar vacío";
      if (
        this.formulario.metaData.horarioContacto == null ||
        this.formulario.metaData.horarioContacto == ""
      )
        this.erroresObligatorios.horarioContacto =
          "Los campos <b>'HORARIO DESDE'</b> y <b>'HORARIO HASTA'</b> son obligatorios y no pueden estar vacíos";
    },

    //envio final
    enviar() {
      if (!this.enviandoIncidencia) {
        this.incidencia = "";
        this.enviandoIncidencia = true;
        this.$API
          .resgistarIncidencia({
            formulario: this.formulario,
            familia: this.pedirDesplegables.idTipoModelo,
          })
          .then((response) => {
            if (response.codigo == 0) {
              this.tipoTextoIncidencia = "success";
              this.incidencia =
                "Se ha generado la incidencia '" +
                response.incidencia +
                "' para tratar su gestión";
              this.vaciarCampos();
            } else {
              this.tipoTextoIncidencia = "warning";
              this.incidencia =
                "Ha habido un error al crear la incidencia. Por favor, intentelo de nuevo más tarde";
            }
            window.scrollTo(0, 0);
            this.enviandoIncidencia = false;
          });
      }
    },
    vaciarCampos() {
      this.localTelefono = "";
      this.localAbonado = "";
      this.localEmail = "";
      this.pedirDesplegables.idTipoModelo = null;
      this.pedirDesplegables.idMarca = null;
      this.formulario = incidencia_formulario;
    },
  },
};
</script>

<style>
@font-face {
  font-family: "TitilliumWeb";
  src: url("/font/titilliumweb-bold-webfont.woff2") format("woff2"),
    url("/font/titilliumweb-bold-webfont.woff") format("woff");
  font-weight: bolder;
  font-style: normal;
}

@font-face {
  font-family: "TitilliumWeb";
  src: url("/font/titilliumweb-regular-webfont.woff2") format("woff2"),
    url("/font/titilliumweb-regular-webfont.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "TitilliumWeb";
  src: url("/font/titilliumweb-semibold-webfont.woff2") format("woff2"),
    url("/font/titilliumweb-semibold-webfont.woff") format("woff");
  font-weight: bold;
  font-style: normal;
}

body {
  font-family: "TitilliumWeb", sans-serif;
  color: #4b4b4b;
  font-size: 15px;
}

input[type="checkbox"] {
  /* Double-sized Checkboxes */
  -ms-transform: scale(2); /* IE */
  -moz-transform: scale(2); /* FF */
  -webkit-transform: scale(2); /* Safari and Chrome */
  -o-transform: scale(2); /* Opera */
  color: #ffffff;
  width: 20px;
  /*vertical-align:middle;*/
  margin-right: 20px;
}

select::selection {
  background-color: #ffffff;
  color: #869296;
}

.select select {
  background: transparent;
  border: none;
  line-height: 1;
  border: 0;
  padding: 0;
  border-radius: 0;
  width: 110%;
  position: relative;
  z-index: 10;
  font-size: 1em;
  color: #6f737d;
}

.select {
  width: 100%;
  font-size: 13px;
  background: #fff;
  position: relative;
  overflow: hidden;
  border: none;
  border-bottom: solid 1px #a9a8aa;
  vertical-align: middle;
  background: url("/img/formulario Rent 2 Rent/ico_arrow_select.png") no-repeat;
  background-position: 100% top;
}

/*p {color: #869296; font-size: 22px; text-align:center}*/

    p {
        /*
  color: #755e66;
  font-size: 22px;
  text-align: center;
*/
        color: #000000;
        font-size: 17px;
        text-align: left;
        margin-left: 30%;
        width: 40%;
    }

   
    

    a {
        font-size: 14px;
        text-decoration: none;
        color: #ffffff;
    }
/*a:link {color:#869296}*/
a:hover {
  color: #2fa5d1;
}
/*.text-datos{border:none; border-bottom:solid 1px #A9A8AA; color:#6F737D; font-size:13px; width:100%}*/
.text-datos {
  border: none;
  border-bottom: solid 1px #a9a8aa;
  color: #755e66;
  font-size: 15px;
  width: 100%;
  border-radius: 0;
}

.button_allowed .btn:hover {
  color: #ffffff;
  cursor: pointer;
}

.button_notAllowed .btn:hover {
  color: #ffffff;
  cursor: not-allowed;
}

/*; transition: all 1s ease; */
.button_allowed {
  background-color: #9be51a;
  color: #ffffff;
  height: 55px;
  width: 100%;
  margin: auto;
  text-align: center;
  padding-top: 15px;
}

.button_allowed:hover {
  background-color: #83c24d;
  color: #ffffff;
  height: 55px;
  width: 100%;
  margin: auto;
  text-align: center;
}

.button_notAllowed {
  background-color: #b8dc99;
  color: #ffffff;
  height: 55px;
  width: 100%;
  margin: auto;
  text-align: center;
  padding-top: 15px;
}

.button_notAllowed:hover {
  cursor: not-allowed;
}

.bloque-cabecera .row-title {
  width: 20%;
  float: right;
  margin-right: 20px;
  margin-top: 5px;
  display: block;
}

.bloque-cabecera .logo {
  width: 70%;
  margin: auto;
  margin-top: 50px;
  display: block;
  background: #fff url("/img/formulario Rent 2 Rent/Logo_Movistar.png") left
    center no-repeat;
  height: 80px;
}
/*.bloque-cabecera {background-color:#F4F4F3; margin-left:-10px; width:110%; border:1px #D3D4D3 solid; height:25px; vertical-align:middle}*/
.bloque-cabecera {
  width: 100%;
}
/*
.bloque-datos .bloque-datos-titulo {
  width: 40%;
  margin: auto;
}*/

/*.bloque-datos .bloque-datos-campos .row-etiqueta {margin-top:20px; color:#869296; font-size:13px; }*/
.bloque-datos .bloque-datos-campos .row-etiqueta {
  margin-top: 20px;
  color: #755e66;
  font-size: 15px;
}

.bloque-datos .bloque-datos-campos .row-campos {
  margin-top: 20px;
}

.bloque-datos .bloque-datos-campos {
  width: 30%;
  margin: auto;
}

.bloque-datos .bloque-alerta {
  width: 40%;
  margin: auto;
}

.bloque-datos .bloque-datos-campos .button_allowed .btn:hover {
  color: #ffffff;
  cursor: pointer;
}

.bloque-datos .bloque-datos-campos .button_notAllowed .btn:hover {
  color: #ffffff;
  cursor: not-allowed;
}

.bloque-datos .bloque-datos-campos .button_allowed {
  background-color: #9be51a;
  color: #ffffff;
  height: 55px;
  width: 100%;
  margin: auto;
  text-align: center;
  border-radius: 5px;
  transition: all 1s ease;
}
/*.bloque-datos .bloque-datos-campos .button_allowed:hover {background-color:#83C24D; color:#FFFFFF; height:40px; width:100%; margin:auto; text-align:center}*/
.bloque-datos .bloque-datos-campos .button_notAllowed {
  background-color: #b8dc99;
  color: #ffffff;
  height: 55px;
  width: 100%;
  margin: auto;
  text-align: center;
}

.bloque-datos .bloque-datos-campos .button_notAllowed:hover {
  cursor: not-allowed;
}

.bloque-datos .texto-informacion a {
  font-size: 18px;
  text-decoration: underline;
  color: #2fa5d1;
}

.bloque-datos .texto-informacion a:link {
  color: #869296;
}

.bloque-datos .texto-informacion a:hover {
  color: #2fa5d1;
}

.bloque-datos .texto-informacion {
  width: 40%;
  margin: auto;
  text-align: left;
  color: #869296;
  font-size: 18px;
}

.bloque-datos {
  width: 100%;
  margin: auto;
  min-height: 280px;
  margin-top: 20px;
  margin-bottom: 50px;
}

.bloque-pie {
  width: 30%;
  color: #869296;
  font-size: 11px;
  margin: auto;
  margin-top: 40px;
  text-align: justify;
}

@media (max-width: 920px) and (min-width: 5px) {
  .bloque-datos .bloque-datos-campos {
    width: 90%;
  }
  /*
  .bloque-datos .bloque-datos-titulo {
    width: 90%;
  }
  */
  .bloque-datos .bloque-alerta {
    width: 90%;
    margin: auto;
  }

    .bloque-datos .bloque-datos-titulo {
        width: 90%;
        margin: auto;

    }

  .bloque-pie {
    width: 90%;
  }

  /*.bloque-cabecera .logo{background: #fff url("../images/Logo_Movistar_small.png") left center no-repeat; width:20%}*/
  .bloque-cabecera .logo {
    width: 50%;
    margin: auto;
    margin-top: 20px;
  }

  .bloque-cabecera .row {
    width: 35%;
    float: right;
    margin-right: 20px;
    margin-top: 2px;
  }

  #capa-logo {
    /*background: #fff url("../images/Logo_Movistar_small.png") left center no-repeat;*/
    width: 17%;
  }
}

.requerimiento {
  color: #869296;
  font-size: 14px;
  margin: auto;
  text-align: justify;
}

</style>